{
  "ANY": {
    "timestamp": {
      "SRC": "ANY",
      "Label": "Timestamp",
      "Type": "Timestamp",
      "Overview": true,
      "Overview Label": false,
      "Overview Detail": false,
      "Overview Detail Label": false,
      "Show missing": false,
      "Primary": false,
      "Hidden": false
    },
    "level": {
      "SRC": "ANY",
      "Label": "Level",
      "Overview": true,
      "Overview Label": true,
      "Overview Detail": false,
      "Overview Detail Label": false,
      "Show missing": true,
      "Primary": false,
      "Hidden": false
    },
    "details": {
      "SRC": "ANY",
      "Label": "Details",
      "Overview": false,
      "Overview Label": false,
      "Overview Detail": true,
      "Overview Detail Label": false,
      "Show missing": false,
      "Primary": true,
      "Hidden": false
    },
    "message": {
      "SRC": "ANY",
      "Label": "Message",
      "Overview": true,
      "Overview Label": false,
      "Overview Detail": false,
      "Overview Detail Label": false,
      "Show missing": false,
      "Primary": false,
      "Hidden": false
    }
  }
}
